import * as React from "react";
import {AxiosResponse} from "axios";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import {Popup} from "../../../../common/components/shared/popup/popup";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {Api} from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import "./openOrCloseAllPopup.scss";

interface OpenOrCloseAllPopupProps {
    popupType: "allowPopup" | "notAllowPopup" | "openAllPopup" | "closeAllPopup" | null;
    confirm: () => void;
    closePopup: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isWaiting?: boolean;
    locationName?: string;
}

export default function OpenOrCloseAllPopup(props: OpenOrCloseAllPopupProps) {
    const isOpenAllPopup = props.popupType === "openAllPopup";
    const className = isOpenAllPopup ? "open-all-popup" : "close-all-popup";

    return (
        <Popup
            open={props.popupType != null}
            className={className}
            header={renderHeader()}
            content={renderContent()}
            actionText={i18n.t("yes")}
            cancelText={i18n.t("no")}
            action={props.confirm}
            cancel={props.closePopup}
            testId={className}
            httpError={renderErrors()}
            isWaiting={props.isWaiting}
        />
    );

    function renderHeader() {
        return (
            i18n.t(`place.entryOrExit.${isOpenAllPopup ? "openAllPopup" : "closeAllPopup"}.header`)
        );
    }

    function renderContent() {
        return (
            <div>
                {i18n.t(`place.entryOrExit.${isOpenAllPopup ? "openAllPopup" : "closeAllPopup"}.content`)}
                <b>{props.locationName}</b>
            </div>
        );
    }

    function renderErrors() {
        return (
            <>
                {!Api.isSuccess(props.response) && (
                    <HttpError
                        response={props.response}
                        cause={i18n.t(`place.entryOrExit.${isOpenAllPopup ? "openAllPopup" : "closeAllPopup"}.errorSuffix`)}
                    />
                )}
            </>
        );
    }
}
